import { media } from '@cloud/shared';
import styled, { css } from 'styled-components';

import { sidebarConfig } from '@ovpn/ui/sidebar';
import Text from '@ovpn/ui/text';
import { color } from '@ovpn/ui/tokens';

export const CopyTenant = styled.div<{ $copied: boolean }>`
    position: relative;

    width: 18px;
    height: 18px;
    margin-left: auto;

    opacity: 0;

    transition: opacity ${sidebarConfig.transitionDuration}ms;

    .ovpn-icon {
        position: absolute;
        top: 0;
        left: 0;

        display: block;
    }

    .icon-copy {
        transition:
            opacity 0.3s,
            transform 0.3s;
    }

    .icon-copied {
        transform: rotate(-180deg) scale(0.5);
        opacity: 0;

        transition:
            opacity 0.3s,
            transform 0.3s;
    }

    ${t =>
        t.$copied &&
        css`
            .icon-copy {
                transform: rotate(180deg) scale(0.5);
                opacity: 0;
            }

            .icon-copied {
                transform: rotate(0deg) scale(1);
                opacity: 1;
            }
        `}
`;

export const Container = styled.div`
    display: flex;
    gap: 4px;
    align-items: center;
    min-height: 56px;
    padding: 0 12px;
    overflow: hidden;

    background: ${color.brand.blueActive};
    border: 1px solid ${color.neutral.subtitle};
    border-radius: 8px;

    ${media.SM`
        margin-top: 80px;
    `}

    &:hover {
        background: ${color.brand.blueHover};

        ${CopyTenant} {
            opacity: 1;
        }
    }

    ${media.SM`
        background: ${color.brand.blueHover};
        
        ${CopyTenant} {
            opacity: 1;
        }
    `}
`;

export const IconContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-shrink: 0;
    align-items: center;
    justify-content: space-between;
    width: 24px;
    height: 24px;
`;

export const CurrentTenant = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 162px;
`;

export const NoWrap = styled(Text)`
    overflow: hidden;

    white-space: nowrap;
    text-overflow: ellipsis;
`;
